"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        // can be toggled between open/closed
        root: function (_a) {
            var open = _a.open;
            var _b = theme.custom.slideout, bgColor = _b.bgColor, contrastText = _b.contrastText;
            return {
                zIndex: 1,
                position: "relative",
                minHeight: "100vh",
                maxHeight: "100vh",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                width: open ? "310px" : "12px",
                backgroundColor: bgColor,
                color: contrastText,
                transitionProperty: "width",
                transitionDuration: "".concat(theme.transitions.duration.standard, "ms"),
                transition: theme.transitions.easing.easeInOut,
            };
        },
        slideout: function (_a) {
            var open = _a.open;
            return ({
                opacity: open ? 1 : 0,
                visibility: open ? "visible" : "hidden",
                transitionProperty: "visibility opacity",
                transitionDuration: "".concat(theme.transitions.duration.standard, "ms"),
                transition: theme.transitions.easing.easeInOut,
            });
        },
        list: {
            padding: 0,
        },
        content: {
            overflowY: "auto",
            paddingBottom: "100px",
            maxHeight: "calc(100vh - 104px)",
            minHeight: "calc(100vh - 104px)",
        },
        // overrides for icon button
        toggleButton: {
            backgroundColor: theme.custom.slideoutToggle.bgColor,
            color: theme.custom.slideoutToggle.contrastText,
            boxShadow: theme.shadows[1],
            padding: "0",
            "&:hover": {
                backgroundColor: theme.custom.slideoutToggle.bgColor,
            },
        },
        // using this for icon button position
        floatingButtonContainer: function (_a) {
            var open = _a.open;
            return ({
                position: "absolute",
                zIndex: 2,
                top: theme.spacing(2),
                right: open ? "-12px" : "-15px", // offset from icon button
            });
        },
        sectionListItem: {
            margin: "".concat(theme.spacing(0.5), "px"),
            width: "calc(100% - ".concat(theme.spacing(2), "px)"),
            borderRadius: theme.spacing(0.5),
            "&.MuiListItem-gutters": {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1),
            },
            "&.MuiListItem-gutters:hover": {
                backgroundColor: "rgba(136,136,136, 0.8)",
            },
            "&.Mui-selected": {
                color: theme.palette.secondary.main,
                backgroundColor: "transparent",
                fontWeight: 500,
            },
            "&.Mui-selected .MuiListItemText-root span": {
                fontWeight: 700,
            },
        },
        endAdornment: {},
    });
});
